import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome';
import { Button } from 'reactstrap';

import callApi from '../../../../util/apiCaller';
import { getLoggedUser } from '../../../User/UserActions';

const WorldlinePayment = ({ intl, order, payment, user, currency, autoTrigger }) => {
    const buttonId = 'creditcard-payment-submit-button';
    const [checkoutUrl, setCheckoutUrl] = useState(null);
    const [isFetching, setIsFetching] = useState(false);

    const handleFetchIntent = () => {
        setIsFetching(true);
        callApi('order/payment/intent', 'POST', { order: order._id, payment: payment.id }).then(result => {
            setIsFetching(!result?.payment?.transaction?.redirectUrl);
            setCheckoutUrl(result?.payment?.transaction?.redirectUrl);
        });
    };

    const triggerRedirect = (intent = 0) => {
        if(checkoutUrl) {
            setTimeout(() => {
                const button = document.getElementById(buttonId);
                if(button) {
                    button.click();
                } else {
                    intent < 5 && triggerRedirect(intent + 1);
                }
            }, intent * 300);
        }
    }

    useEffect(() => {
        autoTrigger && handleFetchIntent();
    }, []);

    useEffect(() => {
        triggerRedirect();
    }, [checkoutUrl]);

    if(!isFetching) {
        if(checkoutUrl) {
            return <Button tag="a" href={checkoutUrl} id={buttonId}><FormattedMessage id="orderPaymentProcessButton" defaultMessage="Process payment" /> <FontAwesome name="check-circle" /></Button>;
        }

        return <Button onClick={handleFetchIntent}><FormattedMessage id="orderPaymentProcessButton" defaultMessage="Process payment" /></Button>;
    }
    return null;
};

function mapStateToProps(store, props) {
    return {
        user: getLoggedUser(store),
        currency: store.currency.currency,
    };
}

WorldlinePayment.defaultProps = {
    user: null,
    autoTrigger: false,
    // subscription: null,
};

WorldlinePayment.propTypes = {
    intl: PropTypes.object.isRequired,
    order: PropTypes.object.isRequired,
    payment: PropTypes.object.isRequired,
    // subscription: PropTypes.object,
    autoTrigger: PropTypes.bool,
    user: PropTypes.object,
    currency: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(injectIntl((WorldlinePayment)));
